var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#3B4B59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.668 20.0859C21.668 19.8098 21.8918 19.5859 22.168 19.5859H28.668C28.9441 19.5859 29.168 19.8098 29.168 20.0859V21.5859C29.168 21.8621 28.9441 22.0859 28.668 22.0859H22.168C21.8918 22.0859 21.668 21.8621 21.668 21.5859V20.0859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8359 22.5859C20.8359 22.3098 21.0598 22.0859 21.3359 22.0859H27.8359C28.1121 22.0859 28.3359 22.3098 28.3359 22.5859V24.0859C28.3359 24.3621 28.1121 24.5859 27.8359 24.5859H21.3359C21.0598 24.5859 20.8359 24.3621 20.8359 24.0859V22.5859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.668 25.0859C21.668 24.8098 21.8918 24.5859 22.168 24.5859H28.668C28.9441 24.5859 29.168 24.8098 29.168 25.0859V26.5859C29.168 26.8621 28.9441 27.0859 28.668 27.0859H22.168C21.8918 27.0859 21.668 26.8621 21.668 26.5859V25.0859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8359 27.5859C20.8359 27.3098 21.0598 27.0859 21.3359 27.0859H27.8359C28.1121 27.0859 28.3359 27.3098 28.3359 27.5859V29.0859C28.3359 29.3621 28.1121 29.5859 27.8359 29.5859H21.3359C21.0598 29.5859 20.8359 29.3621 20.8359 29.0859V27.5859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8359 25.0859C10.8359 24.8098 11.0598 24.5859 11.3359 24.5859H17.8359C18.1121 24.5859 18.3359 24.8098 18.3359 25.0859V26.5859C18.3359 26.8621 18.1121 27.0859 17.8359 27.0859H11.3359C11.0598 27.0859 10.8359 26.8621 10.8359 26.5859V25.0859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.668 27.5859C11.668 27.3098 11.8918 27.0859 12.168 27.0859H18.668C18.9441 27.0859 19.168 27.3098 19.168 27.5859V29.0859C19.168 29.3621 18.9441 29.5859 18.668 29.5859H12.168C11.8918 29.5859 11.668 29.3621 11.668 29.0859V27.5859Z",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.2513L18.2258 14.2788C18.5257 13.9799 19.0021 13.9533 19.3333 14.2171L22.3158 16.603C22.6561 16.8739 23.1474 16.8376 23.4442 16.5196L29.1667 10.418",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 10.418L29.1693 10.418V15.8346",
    stroke: "#3B4B59",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.3e2d030c1ae8658fb090c4957eb90d19.svg";
export { ForwardRef as ReactComponent };